var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIosExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.25,
    height: 22.486,
    viewBox: "0 0 29.25 22.486",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d57575;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.375 -6.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.125,9.563v7.523H22.774l-3.319-3.368a.915.915,0,1,1,1.3-1.287l4.852,4.922a.929.929,0,0,1,.26.64.872.872,0,0,1-.07.352.977.977,0,0,1-.19.288h0l-4.852,4.922a.915.915,0,1,1-1.3-1.287L22.774,18.9H10.125v7.523a2.821,2.821,0,0,0,2.813,2.813H29.813a2.821,2.821,0,0,0,2.813-2.812V9.563A2.821,2.821,0,0,0,29.813,6.75H12.938A2.821,2.821,0,0,0,10.125,9.563Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.289,17.086a.914.914,0,0,0,0,1.828h5.836V17.086Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosExit);
export default __webpack_public_path__ + "static/media/ios-exit.6c16ab2b51a582352bfce6a91aeddf1d.svg";
export { ForwardRef as ReactComponent };